import { api } from "shared/api";
import {
  LoginDTO,
  LoginResponse,
  RegistrationDTO,
  RegistrationResponse,
} from "./models";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import qs from "qs";

export const RegistrationApi = async (dto: RegistrationDTO) => {
  const { data } = await api.post<RegistrationResponse>(
    API_ROUTES.REGISTRATION,
    qs.stringify({ ...dto, ...defaultOptions() })
  );

  return data;
};

export const LoginApi = async (dto: LoginDTO) => {
  const { data } = await api.post<LoginResponse>(
    API_ROUTES.LOGIN,
    qs.stringify({ ...dto, ...defaultOptions() })
  );

  return data;
};
